import { useWeb3React } from '@web3-react/core'
import _ from 'lodash'
import { useLayoutEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import LottieLoading from '~/components/LottieLoading'
import { StyledPipe, StyledTab } from '~/components/Tabs'
import { useGA } from '~/hooks'
import {
  LimitOrderStatus,
  useUserLimitOrderList,
} from '~/hooks/useUserLimitOrderList'
import { useModalOpened } from '~/state/application/hooks'
import { ApplicationModal } from '~/state/application/reducer'
import EmptyOrder from './EmptyOrder'
import Order from './Order'
import { OrderTabs, StyledOrderList, StyledOrderListWrapper } from './styled'

enum OrderStatusTab {
  OPEN = 'open',
  HISTORY = 'history',
}

const OpenOrderStatuses = [
  LimitOrderStatus.Pending,
  LimitOrderStatus.PartialFilled,
]
const HistoryOrderStatuses = [
  LimitOrderStatus.Fulfilled,
  LimitOrderStatus.Cancelled,
  LimitOrderStatus.Expired,
]

const OrderList: React.FC = () => {
  const { t } = useTranslation()
  const { account } = useWeb3React()
  const [activeTab, setActiveTab] = useState(OrderStatusTab.OPEN)
  const tabARef = useRef<HTMLDivElement>()
  const tabBRef = useRef<HTMLDivElement>()
  const { data, error } = useUserLimitOrderList(
    activeTab === OrderStatusTab.OPEN
      ? OpenOrderStatuses
      : HistoryOrderStatuses,
  )
  const isPreviewOpen = useModalOpened(ApplicationModal.LIMIT_ORDER_PREVIEW)

  const { trackClick } = useGA()

  useLayoutEffect(() => {
    if (activeTab === OrderStatusTab.OPEN) {
      tabARef.current?.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      })
    }
    if (activeTab === OrderStatusTab.HISTORY) {
      tabBRef.current?.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      })
    }
  }, [activeTab])

  // 订单预览或钱包未连接时不展示历史订单
  if (isPreviewOpen || !account) return null

  return (
    <StyledOrderListWrapper>
      <OrderTabs>
        <StyledTab
          ref={tabARef}
          active={activeTab === OrderStatusTab.OPEN}
          onClick={() => {
            trackClick('webtl_lo_active')
            setActiveTab(OrderStatusTab.OPEN)
          }}
        >
          {t('open_orders')}
        </StyledTab>
        <StyledPipe />
        <StyledTab
          ref={tabARef}
          active={activeTab === OrderStatusTab.HISTORY}
          onClick={() => {
            trackClick('webtl_lo_history')
            setActiveTab(OrderStatusTab.HISTORY)
          }}
        >
          {t('order_history')}
        </StyledTab>
      </OrderTabs>
      {data?.length === 0 || (error && <EmptyOrder />)}
      {!data && !error && <LottieLoading boxProps={{ my: '50px' }} />}
      <StyledOrderList>
        {_.orderBy(data, ['createdAt'], 'desc').map((order) => (
          <Order key={order?.id} order={order} />
        ))}
      </StyledOrderList>
    </StyledOrderListWrapper>
  )
}

export default OrderList
